// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Background from './pages/Home';
import About from './pages/About';
import Skills from './pages/Skills';
import Contact from './pages/Contact';
import Navbar from './components/Navbar/Navbar';
import FloatingIcons from './components/FloatingIcons';
import './App.css';

export const App = () => {
  return (
    <Router>
      <div className="app-container">
        <Navbar />

        <Routes>
          <Route
            path="/"
            element={
              <div>
                <Background />
                <FloatingIcons />

                <section id="about">
                  <About />
                </section>

                <section id="skills">
                  <Skills />
                </section>

                <section id="contact">
                  <Contact />
                </section>
              </div>
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
